// let HTTP_API = 'http://localhost:9991';
let HTTP_API = 'http://yjz-buyer.com:9991';
if (process.env.NODE_ENV === 'production') {
  //获取域名是http还是https如果是http就使用http://yjz-buyer.com:9991，如果是https就使用https://yjz-buyer.com:9991
  let protocol = window.location.protocol;
  if (protocol === 'http:') {
    HTTP_API = 'http://yjz-buyer.com';
  }
  else if (protocol === 'https:') {
    HTTP_API = 'https://yjz-buyer.com';
  }
  

}

const VITE_SM_PUBLIC_KEY = "041dbcbfc8175068d99d73e2fe56920ef66a6276a5b8e61a11f8adea9dfc1c1ade177ca667492d904179c1d40ee7d763aab33232ae71facf97d77d755710519da3"

export {
  HTTP_API,
  VITE_SM_PUBLIC_KEY,

};
